import React, { useContext, useMemo } from "react";
import BryntumContext from "../../../../context/bryntumContext.jsx";
import { getViewStateIconByRecord } from "../../../../../other/utils/utils.jsx";
import useViews from "../../../../hooks/useViews.jsx";
import AppViewStateInspectButton from "../appViewStateInspectButton/AppViewStateInspectButton.jsx";
import { useRecentViews } from "@/react/context/recentViewsContext.jsx";

const AppSelectedViewButton = () => {
  const { project, user, selectedBoard, entityManager, viewManager } = useContext(BryntumContext);
  const { currentViews } = useRecentViews();
  const viewManagerState = useViews();
  const canShowButton = Boolean(user) && Boolean(selectedBoard);

  const selectedView = viewManagerState?.selectedView;
  const isAnonymousView = typeof selectedView?.id === "string";

  const viewToShow = useMemo(() => {
    if (isAnonymousView) {
      /* First view is the last selected view */
      const [lastSelectedView] = currentViews;
      return lastSelectedView;
    } else {
      return selectedView;
    }
  }, [selectedView, isAnonymousView]);

  if (!canShowButton || !viewToShow) {
    return null;
  }

  const viewIcon = getViewStateIconByRecord(viewToShow, project);

  const handleClick = () => {
    if (isAnonymousView) {
      viewManager.selectView(viewToShow);
    }

    if (entityManager.isOpen) {
      entityManager.closeEntityManager();
    }
  };

  return (
    <button className="relative flex gap-2 items-center" onClick={handleClick} type="button">
      <i className={`${viewIcon} text-sm`} style={viewToShow.color ? { color: viewToShow.color } : undefined} />
      <span className="font-medium text-sm leading-none" style={viewToShow.color ? { color: viewToShow.color } : undefined}>
        {viewToShow.name || "Loading View..."}
      </span>
      <AppViewStateInspectButton />
    </button>
  );
};

export default AppSelectedViewButton;
